function FailIconDiv(props) {
    return (
      <>
        <div className={props.class}>
            <img src={props.src} className="iconimage" alt="logo" />
        </div>
      </>
    );
  }
  
export default FailIconDiv;